import { useSelector } from "react-redux";
import OrdersReports from "../reports/orders-reports/OrdersReports";
import SalesLineChart from "./sub-components/chart/SalesLineChart";
import TotalCommision from "./sub-components/total-commission/TotalCommision";
import { usersState } from "../../sotre/redux/features/userSlice";

export default function Dashboard() {
  const { users } = useSelector(usersState);

  return (
    <div>
      {users && users.mobile === "09301847909" ? null : (
        <>
          <SalesLineChart />
          <OrdersReports />
          <TotalCommision />
        </>
      )}
    </div>
  );
}
